module.exports = __webpack_public_path__ + "static/media/techcrunch.278e16a1.webp";